import { Layout } from 'components';
import { CSSObject, GlobalStyles } from 'libs/ui/styled';

export const AccountLayoutOverrideStyles = () => (
  <GlobalStyles
    styles={(theme) => ({
      [Layout.classes.main.css]: {
        [Layout.classes.header.css]: {
          '.header-wrapper': {
            marginLeft: 64,
            marginRight: 64,
            [theme.breakpoints.down('tablet')]: {
              marginLeft: 16,
              marginRight: 16,
            },
          } as CSSObject,

          '.header-logo-wrapper': {
            width: 34,
            overflow: 'hidden',
            [theme.breakpoints.down('tablet')]: {
              width: 24,
            },
          } as CSSObject,
        },

        [Layout.classes.content.css]: {
          marginLeft: 40,
          marginRight: 40,
          [theme.breakpoints.down('tablet')]: {
            marginLeft: 16,
            marginRight: 16,
          },
        } as CSSObject,

        [Layout.classes.footer.css]: {
          height: '32px !important',
        } as CSSObject,
      },
    })}
  />
);
